import dayjs from 'dayjs'

export const getAge = dateOfBirth => {
  const today = dayjs()
  const birthDate = dayjs(dateOfBirth)
  return today.diff(birthDate, 'year')
}
